import Vue from 'vue'
import Vuetify from 'vuetify'
import pt from 'vuetify/src/locale/pt'
import theme from '@/styles/Theme'

import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import SlaIcon from '@/utils/SlaIcon.vue'
import FinxIcon from '../utils/FinxIcon.vue'
import HisIcon from '../utils/HisIcon.vue'

Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme,
  lang: {
    locales: {
      pt,
    },
    current: 'pt',
  },
  icons: {
    finx: {
      component: FinxIcon,
    },
    his: {
      component: HisIcon,
    },
    sla: {
      component: SlaIcon,
    },
  },
})
